import { GET_COUNTRIES, GET_LANGUAGES, GET_COUNTRIES_LANGUAGES_SUBDOMAIN, OPEN_COUNTRY_DETAILS } from '../actions/action_types';
import { console_log } from "../utils/helper";

const initialState = {
    countries: [],
    languages: [],
    countryDomain: [],
    countryManagement: {}
};

export const CountryReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_COUNTRIES:
            return {
                ...state,
                countries: action.data.data
            };
        case GET_LANGUAGES:
            return {
                ...state,
                languages: action.data.data
            };
        case GET_COUNTRIES_LANGUAGES_SUBDOMAIN:
            return {
                ...state,
                countryDomain: action.data.data
            };
        case OPEN_COUNTRY_DETAILS:
            return {
                ...state,
                countryManagement: action.data
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/CountryReducer.js